import Seo from "../../components/Seo";
import { Reveal, Eyebrow, PageHero, CtaBand } from "../../components/Shared";
import { photo, BUSINESS } from "../../data/site";
import { Phone, ShieldCheck, Wrench, Layers } from "lucide-react";

export default function PPF() {
  return (
    <>
      <Seo
        title="Paint Protection Film (PPF) in Sioux Falls, SD | Free Quote — A+ Detailing"
        description="Paint protection film in Sioux Falls, SD — invisible armor against rock chips, road debris and winter salt. Priced per vehicle with a free quote from A+ Detailing."
        path="/paint-protection-film"
      />
      <PageHero
        eyebrow="Paint Protection Film"
        lines={["INVISIBLE", "ARMOR."]}
        lead="PPF is a clear, durable film applied over your paint to take the beating South Dakota roads dish out — rock chips, road debris and winter salt — while your paint stays flawless underneath."

        chips={["Free quote", "Quoted per vehicle"]}
        testPrefix="ppf"
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28">
        <Reveal><Eyebrow>What PPF protects against</Eyebrow></Reveal>
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {[
            { icon: ShieldCheck, t: "Rock chips & road debris", d: "High-impact zones — hood edges, bumpers, mirrors — shielded from stone damage." },
            { icon: Wrench, t: "Everyday wear", d: "Door edges, load sills and touch points protected from scratches and scuffs." },
            { icon: Layers, t: "Winter salt & grime", d: "A sacrificial barrier against corrosive road treatment all season long." },
          ].map((b, i) => (
            <Reveal key={b.t} delay={i * 0.08}>
              <div className="h-full rounded-2xl border border-white/10 bg-card p-7" data-testid={`ppf-benefit-${i}`}>
                <b.icon size={22} className="text-bright" />
                <h3 className="mt-4 font-display text-lg font-bold">{b.t}</h3>
                <p className="mt-2 text-sm text-steel leading-relaxed">{b.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 rounded-2xl border border-bright/40 bg-gradient-to-br from-bright/10 to-card p-9 sm:p-12 text-center" data-testid="ppf-quote-card">
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight">Free PPF quote</h2>
            <p className="mt-4 text-steel leading-relaxed max-w-xl mx-auto">
              PPF is priced by coverage and vehicle. Call us or send a quote request and
              we'll put together the right package — from high-impact zones to full coverage.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3.5 justify-center">
              <a
                href={BUSINESS.phoneHref}
                data-testid="ppf-call-button"
                className="flex items-center justify-center gap-2 rounded-full bg-bright hover:bg-accent text-white font-semibold px-7 py-3.5 transition-colors"
              >
                <Phone size={16} /> Call {BUSINESS.phone}
              </a>
              <a
                href="/book"
                data-testid="ppf-quote-button"
                className="flex items-center justify-center gap-2 rounded-full border border-white/20 hover:border-bright hover:text-bright text-white font-semibold px-7 py-3.5 transition-colors"
              >
                Request a Free Quote
              </a>
            </div>
          </div>
        </Reveal>
      </section>

      <CtaBand testPrefix="ppf" />
    </>
  );
}
